{
  "title": "AI Configuration",
  "cancel": "Cancel",
  "save": "Save",
  "newPrompt": "New Prompt",
  "editPrompt": "Edit Prompt",
  "configureAI": "Configure AI",
  "update": "Update",
  "create": "Create",
  "confirmDelete": "Are you sure you want to delete this prompt?",
  "delete": "Delete",
  "prompt": "Prompt",
  "promptName": "Prompt Name",
  "promptModel": "Model",
  "actions": "Actions",
  "modelAgent": "Agent Model",
  "promptSystemEnglish": "System Prompt (English)",
  "promptSystemSpanish": "System Prompt (Spanish)",
  "promptScreenEnglish": "Screen Prompt (English)",
  "promptScreenSpanish": "Screen Prompt (Spanish)",
  "promptImageEnglish": "Image Prompt (English)",
  "promptImageSpanish": "Image Prompt (Spanish)",
  "english": "English",
  "spanish": "Spanish",
  "description": "Description",
  "content": "Content",
  "saving": "Saving...",
  "deletePrompt": "Delete Prompt",
  "mainConfig": "Main Configuration",
  "promptSystem": "System Prompt",
  "promptScreen": "Screen Prompt",
  "promptImage": "Image Prompt",
  "prompts": "Prompts"
}
